export type SystemAppIds = { task: string | null; issue: string | null };

export default function setActiveColor(name: string, { task, issue }: SystemAppIds) {
  const path = window.location.pathname.split('/');

  // conditional to separate form/Apps path from system apps
  const formID = (pathname: string[]) => {
    const isForm = pathname[1] === 'apps' || pathname[1] === 'dash';

    if (isForm && (pathname[2] !== task && pathname[2] !== issue)) {
      return pathname[2];
    }

    return '';
  };

  // Map of links to regex paths that should show as active on the sidebar
  const routes = {
    Apps: ['^/apps', `^/apps/${formID(path)}`, `^/dash/${formID(path)}`],
    Dashboard: ['^/$', '^/home'],
    Tasks: ['^/tasks', ...(task ? [`^/dash/${task}`] : [])],
    Issues: ['^/issues', ...(issue ? [`^/dash/${issue}`] : [])],
    Insights: ['^/insights'],
    Groups: ['^/groups'],
    Imports: ['^/imports'],
    Exports: ['^/exports'],
    Projects: ['^/projects'],
    'Map Layers': ['^/layers'],
    'Choice Lists': ['^/choice_lists'],
    'Classification Sets': ['^/classification_sets'],
    'Member Profile': ['^/settings/profile'],
    'Organization Profile': ['^/settings/organization'],
    Billing: ['^/settings/subscription', '^/settings/plans', '^/settings/upgrades', '^/settings/billing'],
    Members: ['^/settings/members'],
    Roles: ['^/settings/roles'],
    API: ['^/settings/api'],
    Webhooks: ['^/settings/webhooks'],
    'Audit Logs': ['^/settings/audit_logs'],
    'Early Access Features': ['^/settings/early_access_features'],
  };

  if (routes[name].some((pathRegex) => new RegExp(pathRegex).test(window.location.pathname))) {
    return { color: '#eb1300', backgroundColor: '#fff' };
  }

  return undefined;
}
